import React, { useEffect, useState } from 'react';
import { SingleChoicePage as PageType, UserProfile } from '../../types/quiz';
import { useLang } from '../../i18n/LangContext';
import '../../assets/scss/quiz-editorial.scss';

interface Props {
    page: PageType;
    userProfile: UserProfile;
    onAnswer: (value: string) => void;
}

const SingleChoicePage: React.FC<Props> = ({ page, userProfile, onAnswer }) => {
    const { lang } = useLang();
    const savedValue = page.data_field ? (userProfile[page.data_field] as string | undefined) : undefined;
    // Pick (highlight) first, advance only on "Next". Local state resets per
    // question (PageRenderer reuses this instance across pages).
    const [selected, setSelected] = useState<string | undefined>(savedValue);

    useEffect(() => {
        setSelected(savedValue);
    }, [page.id, savedValue]);

    const handleNext = () => {
        if (selected) onAnswer(selected);
    };

    return (
        <div className="page page--single-choice">
            <div className="page__container">
                <h2 className="page__question">{page.question}</h2>
                {page.subtitle && <p className="page__subtitle">{page.subtitle}</p>}

                <div className="choice-list">
                    {page.options.map((option) => (
                        <button
                            key={option.id}
                            type="button"
                            className={`choice-list__option ${
                                selected === option.value ? 'choice-list__option--selected' : ''
                            }`}
                            onClick={() => setSelected(option.value)}
                        >
                            {option.icon && <span className="choice-list__icon">{option.icon}</span>}
                            {option.image && (
                                <img src={option.image} alt={option.label} className="choice-list__image" />
                            )}
                            <span className="choice-list__label">{option.label}</span>
                        </button>
                    ))}
                </div>

                {/* Same pinned, full-width action as the matrix screen: one
                    target, always in reach, never hunted for at the end of a
                    long list of options. */}
                <div className="page__actions">
                    <button
                        type="button"
                        className="page__button page__button--block"
                        onClick={handleNext}
                        disabled={!selected}
                    >
                        {lang === 'uk' ? 'Далі →' : 'Next →'}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default SingleChoicePage;
